import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const plansApi = createApi({
  reducerPath: "plansApi",
  baseQuery: customFetchBase({ url: "plan" }),
  endpoints: (builder) => ({
    getPlans: builder.query({
      query: (params = {}) => {
        const {
          page = 1,
          limit = 10,
          search,
          isActive,
          sort = "-createdAt",
        } = params;
        let url = `?page=${page}&limit=${limit}&sort=${sort}`;
        if (search) url += `&q=${search}`;
        if (isActive !== undefined) url += `&isActive=${isActive}`;
        return { url, method: "GET" };
      },
    }),

    getPlanById: builder.query({
      query: (id) => ({
        url: `/${id}`,
        method: "GET",
      }),
    }),

    createPlan: builder.mutation({
      query: (data) => ({
        url: "/",
        method: "POST",
        body: data,
      }),
    }),

    updatePlan: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetPlansQuery,
  useGetPlanByIdQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
} = plansApi;
